// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfq_a bhp_wj bhp_ss bhp_xl"};